function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useMemo } from "react";
import { UserType } from "sprout-graphql";
import { Box, Flex, Text } from "sprout-ui-primitives";
import { media, themeGet } from "sprout-ui-theme";
import styled from "styled-components";
import { getItemUrl, isPresent } from "sprout-lib";
import { Button } from "sprout-ui-dom";
import { PushPinOutlined } from "sprout-ui-icons";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import { sortTopicMembers } from "@sprout/client-lib";
import { CardLink } from "../Card";
import Avatar from "../Avatar";
import useStarTopic from "../Topic/graphql/mutations/useStarTopic";
const TopicV2Wrapper = styled(Box)`
  width: calc(100vw / 2 - 16px - 16px);
  height: 136px;

  ${media.up("small")} {
    width: 258px;
  }

  box-shadow: 0 0 0 ${themeGet("colors.black.10")};
`;
const TopicV2Title = styled(Text)`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow-wrap: break-word;
  word-wrap: break-word;
`;
const TopicV2MembersWrapper = styled(Flex)`
  > * {
    border: 1px solid ${themeGet("colors.white.100")};
  }

  > * + * {
    margin-left: -6px;
  }
`;
const TopicV2MembersMore = styled(Flex)`
  border: 1px solid ${themeGet("colors.black.12")};
`;
const TopicV2PinnedButton = styled(Button)`
  position: absolute;
  top: 8px;
  right: 8px;

  width: 32px;
  height: 32px;
`;
export const TopicV2 = /*#__PURE__*/ forwardRef(function TopicV2ForwardRef(props, ref) {
    var ref1;
    const { topic , dragProvided , isDragging , showPin =false , showUser =false ,  } = props;
    const { id , nodeId , title , rootTopicOrSelf , currentUserHasStarred  } = topic;
    const { owner , topicMembers  } = rootTopicOrSelf || {};
    const memberCount = (rootTopicOrSelf === null || rootTopicOrSelf === void 0 ? void 0 : rootTopicOrSelf.memberCount) || 0;
    const moreCount = memberCount - 3;
    const isWorkspace = (owner === null || owner === void 0 ? void 0 : owner.type) === UserType.Team;
    const currentUser = useCurrentUser();
    const sortedTopicMembers = useMemo(()=>{
        return sortTopicMembers((topicMembers === null || topicMembers === void 0 ? void 0 : topicMembers.nodes) || []).map((topicMember)=>topicMember.user).filter(isPresent);
    }, [
        topicMembers
    ]);
    const starTopic = useStarTopic({
        topicId: id,
        nodeId,
        star: !currentUserHasStarred
    });
    return /*#__PURE__*/ _jsxs(TopicV2Wrapper, _objectSpread({
        position: "relative",
        bg: "white.100",
        borderRadius: "12px"
    }, dragProvided && _objectSpread({}, dragProvided.attributes, dragProvided.listeners, {
        style: dragProvided.style
    }), {
        ref: ref,
        children: [
            !isDragging && /*#__PURE__*/ _jsx(CardLink, {
                to: getItemUrl(topic, (ref1 = topic.rootTopicOrSelf) === null || ref1 === void 0 ? void 0 : ref1.owner)
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                p: 3,
                flexDirection: "column",
                height: "100%",
                children: [
                    /*#__PURE__*/ _jsxs(Box, {
                        pr: 5,
                        children: [
                            isWorkspace && /*#__PURE__*/ _jsx(Text, {
                                fontSize: "11px",
                                fontWeight: "medium",
                                color: "black.60",
                                caps: true,
                                mb: 0,
                                children: owner.firstName || owner.username
                            }),
                            /*#__PURE__*/ _jsx(TopicV2Title, {
                                fontWeight: "bold",
                                children: title || "No title"
                            })
                        ]
                    }),
                    (memberCount > 1 || !isWorkspace && (owner === null || owner === void 0 ? void 0 : owner.id) !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) && showUser) && /*#__PURE__*/ _jsxs(TopicV2MembersWrapper, {
                        alignItems: "center",
                        mt: "auto",
                        children: [
                            sortedTopicMembers.map((topicMember)=>/*#__PURE__*/ _jsx(Avatar, {
                                    user: topicMember,
                                    size: 24
                                }, topicMember.nodeId)),
                            moreCount > 0 && /*#__PURE__*/ _jsx(TopicV2MembersMore, {
                                width: "24px",
                                height: "24px",
                                borderRadius: "50%",
                                alignItems: "center",
                                justifyContent: "center",
                                children: /*#__PURE__*/ _jsxs(Text, {
                                    as: "span",
                                    fontSize: 0,
                                    children: [
                                        "+",
                                        moreCount
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            showPin && /*#__PURE__*/ _jsx(TopicV2PinnedButton, {
                onClick: starTopic,
                variant: "circle",
                color: currentUserHasStarred ? "#f68639" : "black.42",
                children: /*#__PURE__*/ _jsx(PushPinOutlined, {})
            })
        ]
    }));
});
